export function CometLogo({ height = 40, className }: { height?: number; className?: string }) {
  const width = Math.round(height * (1080 / 301));
  return (
    <img
      src="/media/product-icons/logo-comet-wordmark.png"
      alt="comet by innovaccer"
      className={className}
      style={{ height, width, display: 'block', flexShrink: 0 }}
      draggable={false}
    />
  );
}

export default CometLogo;
